import React from "react";
import PageHeader from "components/community/pageHeader/PageHeader";
import "language/i18n";
import Wrapper from "styles/Wrapper";
import PageLeft from "components/community/pageLeft/PageLeft";
import "./Main.scss";
import PageRight from "components/community/pageRight/PageRight";

function Main() {
  return (
    <Wrapper title="" isFooter={true}>
      <div id="content" className="clearfix">
        <PageHeader />
        <section className="page">
          <div className="page-body">
            <div className="row-w clearfix">
              <PageLeft />
              <PageRight />
            </div>
          </div>
        </section>
      </div>
    </Wrapper>
  );
}

export default Main;
